import { useState } from "react"

export default function GridPics(props){
    const [grids] = useState(props.grids)
    return(
        <div className="container flex flex-row w-full justify-center lg:ms-52 md:ms-20 ms-0 mt-20 xl:pe-32 md:pe-3">
            <div className="xlg:w-3/4 md:w-full w-full grid lg:grid-cols-4 md:grid-cols-4 grid-cols-1 xlg:px-20 justify-around gap-10 mx-auto ">
                {grids.map((e)=>{ return(
                    <div className={`flex flex-col justify-center ${props.stylegrids} `}>
                        <img src={e.pic} className="w-[120.21px] h-[100px] ps-3  mx-auto" alt="" />
                        <h3 className="text-center mx-auto mt-5 font-semibold text-3xl">{e.name}</h3>
                    </div>  
                )})}
            </div>
        </div>
    )
}